import React from 'react';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';

import { collapseAll } from '../../../../../store/actions/navigationPanelActions';
import { useAppDispatch } from '../../../../hooks';
import { ButtonBarButton, ButtonBarButtonProps } from './common';

export function CollapseAllButton({ panelContext }: ButtonBarButtonProps) {
  const dispatch = useAppDispatch();
  if (panelContext === 'levels') return null;

  return <ButtonBarButton title="Collapse All" icon={UnfoldLessIcon} onClick={() => void dispatch(collapseAll())} />;
}
